/**
 * Sign-in card OAuth UI toggles.
 * Flip to true when Facebook sign-in should appear again (e.g. after provider rollout).
 */
export const SHOW_FACEBOOK_OAUTH_SIGN_IN_BUTTON = false

export const SHOW_MICROSOFT_OAUTH_SIGN_IN_BUTTON = true

/** Sign in with Apple — required on iOS native (App Store Guideline 4.8); hidden on Android. */
export const APPLE_SIGN_IN_BUTTON_LABEL = 'Continue with Apple'
export const APPLE_SIGN_IN_LOADING_A11Y = 'Signing in with Apple'
